import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProgramPricingInfo from "./ProgramPricingInfo";

function PravoOsnovne() {
  const [t] = useTranslation();

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Pravo" />
      <section className="project-detail">
        <div className="container">
          <div className="lower-content">
            <div className="row">
              <div className="text-column col-lg-9 col-md-9 col-sm-12">
                <h2>{t("osnovnep.title")}</h2>
                <div className="upper-box">
                  <div className="single-item-carousel owl-carousel owl-theme">
                    <figure className="image">
                      <img
                        src="assets/img/bg/Fpep-04.png"
                        alt="Menadžment slika"
                      />
                    </figure>
                  </div>
                </div>
                <div className="inner-column textjustify">
                  <h3>{t("programi.subtitle1")}</h3>
                  <p>{t("osnovnep.opisprograma")}</p>
                  <h4>{t("programi.subtitle2")}</h4>
                  <p>{t("osnovnep.stacetenauciti")}</p>

                  <ul className="pr-ul">
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit1")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit2")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit3")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit4")}</div>
                    </li>
                  </ul>

                  <h3>{t("programi.sadrzajPredmeta")}</h3>

                  <div
                    className="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="accordion" id="accordionExample">
                      <div className="card">
                        <div className="card-header" id="headingThree">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 0 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse0"
                              onClick={() => handleToggle(0)}
                            >
                              {t("programi.prvaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse0"
                          className={`collapse${
                            activeIndex === 0 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/istorija-prava-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/uvod-u-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/rimsko-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/osnovi-ekonomije-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/informacione-tehnologije-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/ustavno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p6")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/uvod-u-pravo-evropskih-integracija-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.p7")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izborni1")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/engleski-jezik-I-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.rfb8")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingFour">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 1 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse1"
                              onClick={() => handleToggle(1)}
                            >
                              {t("programi.prvaIzborna")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse1"
                          className={`collapse${
                            activeIndex === 1 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/sociologija-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvaizborna.p1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/pravna-etika-kultura-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvaizborna.p2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/akademsko-pisanje-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvaizborna.p3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingOne">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 2 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2"
                              onClick={() => handleToggle(2)}
                            >
                              {t("programi.drugaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse2"
                          className={`collapse${
                            activeIndex === 2 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/gradjansko-pravo">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/porodicno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/obligaciono-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/upravno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/radno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/krivicno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p6")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/nasljedno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p7")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/osnovi-kompanijskog-prava-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p8")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/medjunarodno-javno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.p9")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/engleski-jezik-II-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.rfb8")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingTwo">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 3 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse3"
                              onClick={() => handleToggle(3)}
                            >
                              {t("programi.trecaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse3"
                          className={`collapse${
                            activeIndex === 3 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/krivicno-procesno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("trecagodina.p1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/gradjansko-procesno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("trecagodina.p2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/medjunarodno-procesno-pravo-poas">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("trecagodina.p3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izbornimodul1")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izbornimodul2")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.strucnapraksa")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.diplomski")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 className="pt-40">{t("programi.moduli")}</h4>
                  <p>{t("programi.moduliHint")}</p>
                  <table className="table table-bordered mb-40">
                    <thead>
                      <tr>
                        <th>{t("programi.nazivModula")}</th>
                        <th>{t("programi.nazivPredmeta")}</th>
                        <th>{t("programi.modulSemestar")}</th>
                        <th>{t("programi.brojcasovapred")}</th>
                        <th>{t("programi.ects")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>{t("trecagodina.pmodul1")}</strong>
                        </td>
                        <td className="subject-list">
                          <Link to="/stecajno-pravo-poas">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.p4")}
                              </strong>
                            </div>
                          </Link>
                          <hr />
                          <Link to="/kompanijsko-pravo-poas">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.p5")}
                              </strong>
                            </div>
                          </Link>
                        </td>
                        <td>V</td>
                        <td>3/2</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("trecagodina.pmodul2")}</strong>
                        </td>
                        <td className="subject-list">
                          <Link to="/pravo-eu-poas">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.p6")}
                              </strong>
                            </div>
                          </Link>
                          <hr />
                          <Link to="/ljudksa-prava-i-slobode-poas">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.p7")}
                              </strong>
                            </div>
                          </Link>
                        </td>
                        <td>V</td>
                        <td>3/2</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("trecagodina.pmodul3")}</strong>
                        </td>
                        <td className="subject-list">
                          <Link to="/prekrsajno-pravo-poas">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.p8")}
                              </strong>
                            </div>
                          </Link>
                          <hr />
                          <Link to="/notarsko-advokatsko-pravo-poas">
                            <div className="text">
                              <strong>
                                <i className="fas fa-book" />{" "}
                                {t("trecagodina.p9")}
                              </strong>
                            </div>
                          </Link>
                        </td>
                        <td>V</td>
                        <td>3/2</td>
                        <td>6</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3">
                <aside className="sidebar-widget info-column">
                  <div className="inner-column3">
                    <h3>{t("programi.osnovneinfo")}</h3>
                    <ul className="project-info clearfix">
                      <li>
                        <ProgramPricingInfo level="undergrad" t={t} />
                      </li>
                      <li>
                        <span className="icon fas fa-university" />{" "}
                        <strong>{t("programi.tipstudija")}</strong>{" "}
                        <span>{t("programi.akademske")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-calendar-alt" />{" "}
                        <strong>{t("programi.stepenstudija")}</strong>{" "}
                        <span>{t("programi.stepenosnovne")}</span>
                      </li>

                      <li>
                        <span className="icon fas fa-clock" />{" "}
                        <strong>{t("programi.trajanje")} </strong>{" "}
                        <span>{t("programi.trajanje3")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-graduation-cap" />{" "}
                        <strong>{t("programi.zvanje")}</strong>{" "}
                        <span>{t("osnovnep.zvanje")}</span>
                      </li>
                      <li>
                        <div className="slider-btn">
                          <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLSejqXir_pUuSCp0MwDJLzLoTDiT2SphgLQPO8_-5t35dxh5lw/viewform"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn ss-btn smoth-scroll"
                          >
                            {t("programi.apply")}
                            <i className="fas fa-arrow-right" />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default PravoOsnovne;
